import { ConfigObj, ErrObj, eventData } from './@types';
import fetch from './util/fetchtimeout';

const post = async (config: ConfigObj, data: eventData) => {
  if (!config || !data) return;
  try {
    const { endpoint, timeout = 15000 } = config;

    const res = await fetch(
      endpoint,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      timeout
    );

    if (res.status >= 200 && res.status < 300) {
      return 200;
    }

    const err = new Error('API Failed');
    const failed: ErrObj = { ...err, status: 400 };
    throw failed;
  } catch (e: unknown) {
    const error = e as ErrObj;
    if (error.name === 'AbortError') {
      error.status = 408; // failed due to timeout
    } else {
      error.status = 400;
    }
    error.message = 'Post Beacon Failed';
    //error has status key to tell why api got failed
    throw error;
  }
};

export default post;
